// extracted by mini-css-extract-plugin
module.exports = {"volumeButton":"styles_volumeButton__139tH"};